<template>
    <v-app>
        <app-mobile-layout>
            <app-navigation :items="navigationItems" v-if="showAppNavigation"></app-navigation>
            <v-fade-transition hide-on-leave>
                <slot></slot>
            </v-fade-transition>
        </app-mobile-layout>
    </v-app>
</template>

<script>
    import AppMobileLayout from '@/components/AppMobileLayout';
    import AppNavigation from '@/components/AppNavigation';
    import { find } from 'lodash';

    export default {
        name: 'App',
        components: { AppMobileLayout, AppNavigation },
        data: () => ({
            navigationItems: [
                { to: '/', text: 'Map', icon: 'mdi-map' },
                { to: '/trophies', text: 'Trophies', icon: 'mdi-trophy' },
                { to: '/resources', text: 'Resources', icon: 'mdi-book-open-variant' },
                { to: '/settings', text: 'Settings', icon: 'mdi-cog' }
            ]
        }),
        computed: {
            showAppNavigation() {
                return this.$route?.path && find(this.navigationItems, { to: this.$route.path });
            }
        }
    };
</script>
